import React, { useState } from "react";
import styled from "styled-components";
import { MoreHorizontal, Check } from "react-feather";
import Avatar from "./Avatar";
import { rawColors } from "../design-system/tokens/colors";

const CommentBoxWrapper = styled.div<{ $isSelected: boolean }>`
  background-color: ${rawColors.structural.white};
  border: 1px solid ${(props) => (props.$isSelected ? "royalblue" : rawColors.grey[200])};
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: ${(props) => (props.$isSelected ? "royalblue" : "#c0c0c0")};
  }
`;

const CommentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

const NameTimeWrapper = styled.div`
  margin-left: 10px;
`;

const Name = styled.div`
  font-weight: bold;
`;

const Time = styled.div`
  font-size: 12px;
  color: ${rawColors.text.mediumEmphasis};
`;

const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  margin-left: 5px;
  color: ${rawColors.text.mediumEmphasis};
`;
const CommentContent = styled.p`
  argin: 16px 0px 10px 0;
  font-size: 12px;
`;

const ResponsesToggle = styled.button`
  background: none;
  border: none;
  color: royalblue;
  cursor: pointer;
  font-size: 14px;
`;

const CheckmarkCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ResponseContainer = styled.div`
  margin-top: 20px;
`;

interface CommentBoxProps {
  content: string;
  responses?: CommentBoxProps[];
  onSelect: () => void;
  isSelected: boolean;
  user: {
    name: string;
    timestamp: string;
    color: string;
  };
}

const CommentBox: React.FC<CommentBoxProps> = ({
  content,
  responses,
  onSelect,
  isSelected,
  user,
}) => {
  const [showResponses, setShowResponses] = useState(false);

  const renderContent = (text: string) => {
    return text
      .split(" ")
      .map((word, index) =>
        word.startsWith("@") ? <strong key={index}>{word} </strong> : word + " "
      );
  };
  return (
    <CommentBoxWrapper $isSelected={isSelected} onClick={onSelect}>
      <CommentHeader>
        <UserInfo>
          <Avatar name={user.name} color={user.color} />
          <NameTimeWrapper>
            <Name>{user.name}</Name>
            <Time>{user.timestamp}</Time>
          </NameTimeWrapper>
        </UserInfo>
        <HeaderIcons>
          <IconButton>
            <MoreHorizontal size={14} />
          </IconButton>
          <IconButton>
            <CheckmarkCircle>
              <Check size={12} />
            </CheckmarkCircle>
          </IconButton>
        </HeaderIcons>
      </CommentHeader>
      <CommentContent>{renderContent(content)}</CommentContent>
      {responses && responses.length > 0 && (
        <>
          <ResponsesToggle onClick={() => setShowResponses(!showResponses)}>
            {showResponses ? "Hide Responses" : "Show Responses"}
          </ResponsesToggle>
          {showResponses &&
            responses.map(
              (response, index) => (
                <ResponseContainer>
                  <CommentHeader>
                    <UserInfo>
                      <Avatar
                        name={response.user.name}
                        color={response.user.color}
                      />
                      <NameTimeWrapper>
                        <Name>{response.user.name}</Name>
                        <Time>Just now</Time>
                      </NameTimeWrapper>
                    </UserInfo>
                    <HeaderIcons>
                      <IconButton>
                        <MoreHorizontal size={14} />
                      </IconButton>
                      {/* <IconButton>
                        <CheckmarkCircle>
                          <Check size={12} />
                        </CheckmarkCircle>
                      </IconButton> */}
                    </HeaderIcons>
                  </CommentHeader>
                  <CommentContent>
                    {renderContent(response.content)}
                  </CommentContent>
                </ResponseContainer>
              )
            )}
        </>
      )}
    </CommentBoxWrapper>
  );
};

export default CommentBox;
